import { ViewRouteConfig } from '@scoring-web/configs/route/route.type';
import { lazyWithPreload } from '@ui/utils/lazy.util';

export const LazyAssessmentListView = lazyWithPreload(() => import('./assessment-list.view'));

const assessmentListRoute: ViewRouteConfig = {
  lazy: { Component: async () => LazyAssessmentListView },
  path: '/assessments',
};

export default assessmentListRoute;
